
import { RevToast } from '@backmarket/design-system'
import { PortalTarget } from 'portal-vue'

import {
  DEFAULT_TOAST_STATE,
  TOAST_PORTAL_NAME,
} from './ToastWrapper.constants'
import translations from './ToastWrapper.translations'

export default {
  components: {
    PortalTarget,
    RevToast,
  },
  provide() {
    return {
      closeToast: this.closeToast,
      openToast: this.openToast,
      openErrorToast: this.openErrorToast,
      openSuccessToast: this.openSuccessToast,
      setToastIcon: this.setToastIcon,
      setToastPortalUsage: this.setToastPortalUsage,
      setToastTitle: this.setToastTitle,
      setToastContent: this.setToastContent,
      setToastType: this.setToastType,
      TOAST_PORTAL_NAME,
    }
  },
  data() {
    return {
      toast: {
        ...DEFAULT_TOAST_STATE,
      },
    }
  },
  computed: {
    translations: () => translations,
    TOAST_PORTAL_NAME: () => TOAST_PORTAL_NAME,
  },
  methods: {
    closeToast() {
      Object.keys(DEFAULT_TOAST_STATE).forEach((key) => {
        this.$set(this.toast, key, DEFAULT_TOAST_STATE[key])
      })
    },
    openToast() {
      this.toast.isOpened = true
    },
    openErrorToast({ title, content } = {}) {
      // those values (error and success) are variant of the RevToast DS component.
      // toDo: export them in DS and import them here
      this.setToastType('error')
      this.setToastTitle(title || this.$t(translations.defaultToastErrorTitle))
      this.setToastContent(
        content || this.$t(translations.defaultToastErrorContent),
      )
      this.openToast()
    },
    openSuccessToast({ title, content, icon } = {}) {
      this.setToastType('success')
      this.setToastTitle(
        title || this.$t(translations.defaultToastSuccessTitle),
      )
      this.setToastContent(
        content || this.$t(translations.defaultToastSuccessContent),
      )
      this.setToastIcon(icon || DEFAULT_TOAST_STATE.icon)
      this.openToast()
    },
    setToastIcon(icon) {
      this.toast.icon = icon
    },
    setToastPortalUsage(hasPortal) {
      this.toast.hasPortal = hasPortal
    },
    setToastTitle(title) {
      this.toast.title = title
    },
    setToastContent(content) {
      this.toast.content = content
    },
    setToastType(type) {
      this.toast.type = type
    },
  },
}
